import React, { useEffect, useState } from "react";
import classes from "./InputWithButton.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { EmailButtonArrow } from "../../constant/imagePath";
import PropTypes from "prop-types";
import { Input } from "../Input/Input";
import { ReactSVG } from "react-svg";

export const InputWithButton = ({
  customStyle,
  inputStyle,
  buttonStyle,
  onClick,
  btnIcon,
  iconStyle,
  placeholder,
  state,
  setter,
  className,
  btnClass,
  ...props
}) => {
  return (
    <div
      className={`${classes.inputContainer} ${className && className}`}
      style={{
        ...customStyle,
      }}
    >
      <Input
        state={state}
        setter={setter}
        placeholder={placeholder}
        customStyle={{
          height: "100%",
          width: "100%",
        }}
        inputStyle={{
          padding: "12px 20px 12px 16px",
          ...Fonts.input2,
          lineHeight: "16px",
          height: customStyle?.height ? customStyle?.height : "40px",
          ...inputStyle,
        }}
        {...props}
      />
      <button
        style={{ backgroundColor: Colors.neutralShadesOfNero, ...buttonStyle }}
        onClick={onClick}
        className={`${classes.iconBtn} ${btnClass && btnClass}`}
      >
        <ReactSVG
          src={btnIcon ? btnIcon : EmailButtonArrow}
          style={{ ...iconStyle }}
        />
      </button>
    </div>
  );
};

InputWithButton.propTypes = {
  customStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  buttonStyle: PropTypes.object,
  iconStyle: PropTypes.object,
  onClick: PropTypes.func,
  setter: PropTypes.func,
  btnIcon: PropTypes.string,
  placeholder: PropTypes.string,
  state: PropTypes.string,
};

InputWithButton.defaultProps = {
  customStyle: {},
  inputStyle: {},
  buttonStyle: {},
  onClick: {},
  iconStyle: {},
  placeholder: "Email",
  state: "",
};
